import { SortDirection, QueryProductSearchArgs } from 'types/schema';

export function handleParseQueryParams(queryParams: QueryProductSearchArgs) {
  const productFilterSchema = {
    categoryIds: 'number[]',
    query: 'string',
    brandIds: 'number[]',
    origins: 'string[]',
  };
  const filterParsed = Object.entries(queryParams?.filter).reduce((acc, [key, value]) => {
    if (key === 'subCategoryId') {
      acc['categoryIds'] = String(value)
        ?.split(', ')
        .map((vl) => Number(vl));
    } else {
      const fieldType = productFilterSchema?.[key];
      const fieldValue = String(value);
      if (fieldType === 'string') {
        acc[key] = fieldValue;
      }
      if (fieldType === 'string[]') {
        acc[key] = fieldValue?.split(', ');
      }
      if (fieldType === 'number[]') {
        acc[key] = fieldValue?.split(', ')?.map((item) => Number(item));
      }
    }
    return acc;
  }, {});
  let parsedSort = [];
  if (queryParams?.sort?.length) {
    const splitSort = queryParams?.sort?.split(', ') || [];
    parsedSort = splitSort?.map((sortItem) => {
      const order = sortItem.startsWith('-') ? SortDirection.Desc : SortDirection.Asc;
      const field = sortItem.replace(/^-/, '');
      return { field: field, order: order };
    });
  }
  return {
    ...queryParams,
    filter: {
      ...filterParsed,
    },
    sort: parsedSort,
  };
}
